module.exports = __webpack_public_path__ + "static/media/dugme_xPAY_transparentna_podloga.1f3cb5e7.png";